var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgVerifiedEsg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 89.9999,
    rx: 84,
    ry: 84,
    transform: "rotate(-90 90 89.9999)",
    fill: "#FCE54D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 89.9999,
    rx: 84,
    ry: 84,
    transform: "rotate(-90 90 89.9999)",
    fill: "#FCE54D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 90.0001,
    rx: 63,
    ry: 63,
    transform: "rotate(-90 90 90.0001)",
    fill: "#FCE54D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 90.0001,
    rx: 63,
    ry: 63,
    transform: "rotate(-90 90 90.0001)",
    fill: "#FCE54D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 90,
    rx: 42,
    ry: 42,
    transform: "rotate(-90 90 90)",
    fill: "#FCE54D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 90,
    rx: 42,
    ry: 42,
    transform: "rotate(-90 90 90)",
    fill: "#FCE54D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 89.9999,
    rx: 21,
    ry: 21,
    transform: "rotate(-90 90 89.9999)",
    fill: "#FCE54D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 89.9999,
    rx: 21,
    ry: 21,
    transform: "rotate(-90 90 89.9999)",
    fill: "#FCE54D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVerifiedEsg);
export default __webpack_public_path__ + "static/media/IMG_verified_esg.471834171f327d0fae130f2804b7d395.svg";
export { ForwardRef as ReactComponent };